import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsUnitestInv(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isUnitest = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return protocol.toUpperCase() === "UNITEST_INV";
  }, [Iv_list, SelInverter]);

  return isUnitest;
}
